"use strict"
import React, {Component} from "react";
import {PropTypes, RenderContent, types} from "Subschema";

export default class CheckboxTemplate extends Component {
    static propTypes = {
        error: PropTypes.error,
        title: PropTypes.title,
        label: PropTypes.content,
        showOneTouchTooltip: PropTypes.bool,
        style: PropTypes.style,
        checked: PropTypes.bool,
        id: PropTypes.id,
        path: PropTypes.path,
        Content: PropTypes.injectClass,
    };

    static defaultProps = {
        style: "Checkbox",
        checkedClass: "",
        uncheckedClass: "",
        checkboxClass: ""
    };

    static injectedProps = {
        Content: types.Content
    };

    render() {
        const {
            showOneTouchTooltip
        } = this.props;

        const {children, checkboxClass, checked, checkedClass, path, id, uncheckedClass, title, label, error, Content, hasErrorClass, errorBlockClass, spanIconClass} = this.props;

        return (<div className={`${checkboxClass} ${checked ? checkedClass : uncheckedClass} ${error ? hasErrorClass : ''}`}>
            {children}
            <span className={spanIconClass}></span>
            {label ?
                <label htmlFor={id || path} style = {{width: "90%"}}>
                    { showOneTouchTooltip ? <OneTouch/> : <RenderContent content={label}/> }
                </label> :
                <label htmlFor={id || path} dangerouslySetInnerHTML={{__html:label || title}}/>
            }
            { error ?<div className={errorBlockClass}><Content content={error} key='error-block'/></div> : null }
        </div>);
    }
}


class OneTouch extends Component {
    constructor(){
        super();
        this.state = {
            expanded: false
        }
    }
    render(){
        return <div>
            <div style = {{height: "30px"}}
                onClick={(e)=>{
                    this.setState({expanded: !this.state.expanded})
                }}>
                <div style = {{
                    position: "relative",
                    top: "50%",
                    transform: "translateY(-50%)",
                    "-webkit-transform": "translateY(-50%)"}}>
                    Stay logged in for faster checkout
                </div>
                <button style={{
                    float:"right",
                    border:"none",
                    background: "url(https://www.paypalobjects.com/webstatic/i/consumer/onboarding/questionMark_2x.png) no-repeat",
                    width: "25px",
                    height:" 25px",
                    backgroundSize: "80%",
                    marginTop: "-11px"
                }}
                onClick={(e)=>{
                    this.setState({expanded: !this.state.expanded})
                }}/>
            </div>
            { this.state.expanded ?
                <div style = {{marginLeft: "-45px", marginRight: "12px"}}>
                    <ul>
                        <li style = {{paddingBottom: "10px"}} > No more typing in your password every time you shop on this device. </li>
                        <li style = {{paddingBottom: "10px"}} > Speed through checkout at select merchants.  </li>
                        <li> You're in control - you can turn this off at any time. <br/><br/>
                        For your security, we'll always ask you to log in to update your PayPal personal or financial info. </li>
                    </ul>
                </div> : null }
        </div>
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/CheckboxTemplate.jsx
 **/